import React from 'react';
import { useLanguage } from '../../context/LanguageContext';
import LanguageSwitcher from '../UI/LanguageSwitcher';

interface UnavailableDialogProps {
  onBackToMerchant?: () => void;
}

const UnavailableDialog: React.FC<UnavailableDialogProps> = ({
  onBackToMerchant
}) => {
  const { t } = useLanguage();

  const XIcon = () => (
    <svg width="56" height="56" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M14 14L42 42M42 14L14 42" stroke="#EF4444" strokeWidth="6" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  );

  return (
    <div className="unavailable-dialog">
      <div className="dialog-header">
        <LanguageSwitcher />
      </div>
      <div className="unavailable-dialog__content-wrapper">
        <div className="unavailable-dialog__icon">
          <div className="unavailable-dialog__icon-inner">
            <XIcon />
          </div>
        </div>
        <div className="unavailable-dialog__content">
          <h2 className="unavailable-dialog__title">{t('unavailableTitle')}</h2>
          <p className="unavailable-dialog__desc">{t('unavailableDescription')}</p>
        </div>
      </div>
      {onBackToMerchant && (
        <div className="unavailable-dialog__actions">
          <button
            className="modal-button modal-button--primary"
            onClick={onBackToMerchant}
          >
            {t('backToMerchant')}
          </button>
        </div>
      )}
    </div>
  );
};

export default UnavailableDialog;
